/**
 * 대시보드 관련 헬퍼 함수들
 */

/**
 * compactType에 따른 표시 텍스트 반환
 * @param {string} type - compact type ('vertical', 'horizontal', 'none')
 * @returns {string} 표시할 텍스트
 */
export const getCompactTypeLabel = (type) => {
  switch(type) {
    case 'vertical': return '상하 밀기';
    case 'horizontal': return '좌우 밀기';
    case 'none': return '밀기 없음';
    default: return '상하 밀기';
  }
};

/**
 * 대시보드 템플릿에서 유효한 컴포넌트 배열을 추출
 * @param {Object} dashboardTemplate - 대시보드 템플릿 객체
 * @returns {Array} 유효한 컴포넌트 배열
 */
export const getValidComponentsArray = (dashboardTemplate) => {
  const componentsArray = (dashboardTemplate && typeof dashboardTemplate === 'object' && dashboardTemplate.components) 
    ? dashboardTemplate.components 
    : [];
  
  return componentsArray.filter(comp => comp && comp.id && typeof comp.id === 'string');
};

/**
 * 인증 오류인지 확인
 * @param {string} error - 오류 메시지
 * @returns {boolean} 인증 오류 여부
 */
export const isAuthError = (error) => {
  return error.includes('토큰') || 
         error.includes('인증') || 
         error.includes('Unauthorized') || 
         error.includes('requiresAuth');
};

/**
 * 새 차트 컴포넌트의 기본 템플릿 생성
 * @returns {Object} 새 차트 템플릿 객체
 */
export const createNewChartTemplate = () => {
  const newComponentId = `chart_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
  const defaultWidth = 6;
  const defaultHeight = 4;

  return {
    id: newComponentId,
    title: "새 차트",
    chart_options: { viz_type: 'markdown' },
    data_source: {
      type: 'static',
      content: `<div class="new-chart-placeholder">
  <div class="new-chart-icon">📊</div>
  <div class="new-chart-text">NEW CHART</div>
  <div class="new-chart-desc">여기에 새 차트가 표시됩니다</div>
  <div class="new-chart-hint">템플릿을 편집하여 차트 유형을 변경하세요</div>
</div>`
    },
    w: defaultWidth, 
    h: defaultHeight,
  };
}; 